<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl m-4">
        <div class="flex justify-between p-5 px-8 bg-primary rounded-t-2xl ">
            <div class="text-3xl text-white self-center"><b>
                    Create Work Planning Budget
                    <!-- {{ wpbRecord?.stringShortName }} -->
                </b></div>
        </div>

        <div class="p-12">
            <form [formGroup]="wpbForm">
                <div *ngIf="!isCmIdEmpty" class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-2">
                        <mat-label>Field Name</mat-label>
                        <input matInput formControlName="fieldLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Platform Name</mat-label>
                        <input matInput formControlName="platformLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Well String Name</mat-label>
                        <input matInput formControlName="stringShortName" />
                    </mat-form-field>
                </div>

                <ng-container *ngIf="isCmIdEmpty">

                    <app-table-filter [searchForm]="searchForm" (stringResult)="onSelectedString($event)"
                        class="text-primary"></app-table-filter>
                </ng-container>

                <div class="divider" [ngClass]="isCmIdEmpty ? 'my-6' : 'mt-3 mb-6'"></div>

                <div class="grid grid-cols-4 gap-x-8 mt-4">
                    <mat-form-field class="col-span-2">
                        <mat-label>Integrity Issue</mat-label>
                        <input matInput formControlName="integrityIssue" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Submission Date</mat-label>
                        <input matInput [matDatepicker]="submissionDate" formControlName="submissionDate" />
                        <mat-datepicker-toggle matIconSuffix [for]="submissionDate"></mat-datepicker-toggle>
                        <mat-datepicker #submissionDate></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Submission Year</mat-label>
                        <input matInput formControlName="submissionYear" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Submission Type</mat-label>
                        <input matInput formControlName="submissionType" />
                    </mat-form-field>

                </div>

                <div class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-2">
                        <mat-label>Plan Execution Date</mat-label>
                        <input matInput [matDatepicker]="planExecutionDate" formControlName="planExecutionDate" />
                        <mat-datepicker-toggle matIconSuffix [for]="planExecutionDate"></mat-datepicker-toggle>
                        <mat-datepicker #planExecutionDate></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Plan Cost (RM)</mat-label>
                        <span matTextSuffix>Mil</span>
                        <input type="number" matInput formControlName="planCostRmMil" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="wpbStatus">
                            <mat-select-trigger class="rounded">
                                <span class="p-2 font-semibold" [ngClass]="{
                                    'bg-yellow': wpbForm.get('wpbStatus')?.value === 'Open',
                                    'bg-green': wpbForm.get('wpbStatus')?.value === 'Closed'
                                }">
                                    {{ wpbForm.get('wpbStatus')?.value || 'Select Status' }}
                                </span>
                            </mat-select-trigger>

                            <mat-option [value]="'Open'">
                                <div class="bg-yellow p-2 rounded text-center text-black w-20">Open</div>
                            </mat-option>
                            <mat-option [value]="'Closed'">
                                <div class="bg-green p-2 rounded text-center text-black w-20">Closed</div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Actual Cost (RM)</mat-label>
                        <span matTextSuffix>Mil</span>
                        <input matInput type="number" formControlName="actualCostRmMil" />
                        <mat-error *ngIf="wpbForm.controls.actualCostRmMil.hasError('required')">
                            Actual Cost is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-4 mt-2">
                        <mat-label>Proposal Description</mat-label>
                        <textarea matInput formControlName="proposalDesc" rows="5"></textarea>
                    </mat-form-field>

                    <mat-form-field class="col-span-4">
                        <mat-label>Remark</mat-label>
                        <textarea matInput formControlName="remark" rows="5"></textarea>
                    </mat-form-field>
                </div>
            </form>

            <span *ngIf="isCmIdEmpty" class="flex justify-end text-gray-400 italic text-md">*Please select a String Name to create Work Planning
                Budget</span>
        </div>
    </div>
</div>


<div class="fixed bottom-0 right-0 p-4 bg-card w-full">
    <div class="flex justify-end">
        <button class="btn btn-primary" (click)="location.back()">
            Back
        </button>
        <button class="btn btn-primary mx-2" (click)="wpbPage()">
            To WPB
        </button>
        <button class="btn btn-outline btn-default" [disabled]="disabledCreate()" (click)="createWpb()">
            Create
        </button>
    </div>
</div>